import { socialPublishStatusToTextAndColor } from "@/utils";
import SandboxIcon from "@/assets/icons/svg/hourglass.svg?react";
import { DENMARK_ROTATING_STATUS } from "@/utils/constants/uiConstants";

const rotatingStyles = `
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
    100% { transform: rotate(0deg); }
  }
  .rotating-sandbox {
    animation: rotate 2s infinite linear;
    display: inline-block;
    width: 16px !important;
    height: 16px !important;
    min-width: 16px !important;
    min-height: 16px !important;
    flex-shrink: 0;
  }
`;

// Inject styles once (singleton pattern)
let stylesInjected = false;
const injectRotatingStyles = () => {
  if (stylesInjected || typeof document === "undefined") {
    return;
  }

  // Check if style already exists
  const existingStyle = document.getElementById("rotating-sandbox-styles");
  if (existingStyle) {
    stylesInjected = true;
    return;
  }

  const styleSheet = document.createElement("style");
  styleSheet.id = "rotating-sandbox-styles";
  styleSheet.innerText = rotatingStyles;
  document.head.appendChild(styleSheet);
  stylesInjected = true;
};

export const renderStatusIndicator = (status: number) => {
  // Ensure styles are injected
  injectRotatingStyles();

  const statusText = socialPublishStatusToTextAndColor(status).statusText;

  if (DENMARK_ROTATING_STATUS.includes(status)) {
    return (
      <SandboxIcon
        className="rotating-sandbox"
        width={16}
        height={16}
        role="img"
        aria-label={statusText}
        style={{ flexShrink: 0 }}
      />
    );
  }

  return (
    <span
      role="img"
      aria-label={statusText}
      tabIndex={0}
      className={`rounded-circle d-inline-block ${
        socialPublishStatusToTextAndColor(status).statusColor
      }`}
      style={{
        height: "10px",
        width: "10px",
        flex: "0 0 10px",
        maxWidth: "10px",
      }}
    />
  );
};
